import PropTypes from "prop-types"

import LandingImage from "components/landing/image"
import LandingLink from "components/landing/link"
import Textarea from "components/landing/textarea"
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from "components/ui/carousel"
import { cn } from "styles/utils"

import LandingSlider from "./landing-slider"
import LooksSlider from "./slider/looks-slider"
import ProductCarousel from "./slider/product-carousel"

const LandingCarouselBlock = ({ element, lazyload }) => {
  if (!element || !element.data) return null

  const {
    arrow_props,
    carousel_props,
    content_props,
    item_props,
    name,
    opts,
    slides,
    type,
    viewport_props,
    ...data
  } = element.data
  const { block_props, container_props, textarea_container_props } =
    element.style || {}
  const { className: blockClassName, ...blockProps } = block_props || {}
  const { className: containerClassName, ...containerProps } =
    container_props || {}
  const { className: textareaContainerClassName, ...textareaContainerProps } =
    textarea_container_props || {}

  let carousel = null

  if (type === "featured") {
    carousel = (
      <LandingSlider
        element={{
          anchor_name: element?.anchor_name,
          arrow_style: {
            arrowIcon: "arrow-white-transparent.svg",
            height: "60px",
            top: "50%",
            width: { desktop: "24px", tablet: "30px" },
            ...arrow_props,
          },
          id: element?.id,
          items: slides,
          name,
          slider_type: type || "native",
          ...data,
        }}
        lazyload={lazyload}
      />
    )
  } else if (type === "looks") {
    carousel = (
      <LooksSlider
        element={{
          arrow_style: {
            arrowIcon: "arrow-dark-transparent.svg",
            nextPlacement: "-8px",
            prevPlacement: "-8px",
            top: "37%",
            ...arrow_props,
          },
          name,
          ...element,
        }}
      />
    )
  } else if (type === "ui") {
    const { className: carouselClassName, ...carouselProps } =
      carousel_props || {}
    const { className: contentClassName, ...contentProps } = content_props || {}
    const { className: itemClassName, ...itemProps } = item_props || {}
    const { className: viewportClassName } = viewport_props || {}
    const { className: arrowClassName, ...arrowProps } = arrow_props || {}

    carousel = (
      <Carousel className={carouselClassName} opts={opts} {...carouselProps}>
        <CarouselContent
          className={contentClassName}
          viewportClassName={viewportClassName}
          {...contentProps}
        >
          {slides.map((slide, i) => (
            <CarouselItem
              className={itemClassName}
              key={`${element.anchor_name || element.id}-carousel-${i}`}
              {...itemProps}
            >
              {/* <SliderItem
                element={element}
                index={i}
                item={slide}
                lazyload={lazyload}
              /> */}
              <LandingLink
                linkClickData={element.anchor_name || element.id}
                style={slide.style}
                url={slide.link}
              >
                {slide.image && (
                  <LandingImage image={slide.image} lazyload={lazyload} />
                )}
                {slide.textarea && (
                  <Textarea
                    element={slide.textarea}
                    linkClickData={element.anchor_name || element.id}
                    style={slide.textarea.style}
                  />
                )}
              </LandingLink>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className={arrowClassName} {...arrowProps} />
        <CarouselNext className={arrowClassName} {...arrowProps} />
      </Carousel>
    )
  }

  return (
    <div
      className={cn("widescreen:py-60 py-32", blockClassName)}
      {...blockProps}
    >
      <div className={cn(containerClassName)} {...containerProps}>
        {type === "product" && (
          <ProductCarousel
            data={element.data}
            lazyload={lazyload}
            linkClickData={element.anchor_name || element.id}
          />
        )}
        {element.textarea && (
          <div
            className={cn("px-24 text-center", textareaContainerClassName)}
            {...textareaContainerProps}
          >
            <Textarea
              element={element.textarea}
              linkClickData={element?.anchor_name || element?.id}
            />
          </div>
        )}
        {carousel}
      </div>
    </div>
  )
}

LandingCarouselBlock.propTypes = {
  element: PropTypes.object,
  lazyload: PropTypes.bool,
}

export default LandingCarouselBlock
